import template from './component.tpl.html';
import AlGuestlistTemplatesController from './controller';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-landingpage-editor
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-guestlist-templates guestlist="{}"></al-guestlist-templates>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.guestlists')
    .component('alGuestlistTemplates', {
        bindings: {
            guestlist: '<'
        },
        controller: AlGuestlistTemplatesController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-templates/component.js